import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { catchError, from, map, Observable, throwError, switchMap, of } from "rxjs";
import { CipherService } from "../cipher-config/cipher.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CipherModel } from "../cipher-config/cipher.model";
import * as CryptoJS from 'crypto-js';
import { ConstantValues } from "../../common/constant-values";
import { AdminManagementService } from "../../services/adminmanagement/adminmanagement.service";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private cipherService: CipherService,
    private service: AdminManagementService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  // private async handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    
  //   let authReq = this.addTokenToHeader(request);

  //   if (authReq.body && !(authReq.body instanceof FormData)) {
  //     authReq = await this.addHashToRequest(authReq);
  //   } else if (authReq.body && authReq.body instanceof FormData) {
  //     authReq = await this.addHashToFormData(authReq);
  //   }

  //   return next.handle(authReq).pipe(
  //     map(async (event: HttpEvent<any>) => {
  //       if (event instanceof HttpResponse) {
  //         if (event.body && event.body.MsgData != null && event.body.MsgData !== '') {
  //           const responseHash = String(await this.calculateHashForResponse(event.body, CipherModel.HASH_KEY));
  //           const responseHashValue = String(event.body.HashValue);

  //           if (responseHash !== responseHashValue) {
  //             event.body.MsgResponse.ResponseCode = ConstantValues.HASH_MISMATCH_ERROR;
  //           }
  //         }
  //         if (event.body) {
  //           return event.clone({ body: event.body });
  //         }
  //       }
  //       return event;
  //     }),
  //     catchError((error: HttpErrorResponse) => {
  //       if (error.status === 401) {
  //         console.log('401', authReq, next);
  //         return this.handle401Error(authReq, next);
  //       }
  //       return throwError(() => error);
  //     })
  //   ).toPromise() as unknown as HttpEvent<any>;
  // }


  private async handleAccess(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Promise<HttpEvent<any>> {

      let authReq = request;

      // Only add default token for normal API
      if (!request.headers.has('Authorization') && !request.headers.has('X-Skip-Auth')) {
        const token = this.getToken();
        if (token) {
          authReq = request.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
        }
        // console.log('Token successfully attached to:', request.url);
      }
      
      // 🔑 Hashing
      if (authReq.body && !(authReq.body instanceof FormData)) {
        authReq = await this.addHashToRequest(authReq);
      } else if (authReq.body instanceof FormData) {
        authReq = await this.addHashToFormData(authReq);
      }

      return next.handle(authReq).pipe(
        map(async (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.body) {
            if (event.body.MsgData != null && event.body.MsgData !== '' && !event.body.MsgData?.HashValue) {
                console.log('calculate hash')
                const responseHash = String(
                  await this.calculateHashForResponse(event.body, CipherModel.HASH_KEY)
                );

                if (responseHash !== String(event.body.HashValue)) {
                  event.body.StatusCode = ConstantValues.HASH_MISMATCH_ERROR;
                }
              }
            // console.log('event.body', event.body)
            // else if(event.body != null && event.body !== ''){
            //   const responseHash = String(
            //     await this.calculateHashForResponse(event.body, CipherModel.HASH_KEY)
            //   );

            //   if (responseHash !== String(event.body.HashValue)) {
            //     event.body.StatusCode = ConstantValues.HASH_MISMATCH_ERROR;
            //   }
            // }

            return event.clone({ body: event.body });
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          // Only refresh default token APIs
          if (error.status === 401 && !request.headers.has('X-Skip-Auth')) {
            return this.handle401Error(authReq, next);
          }
          return throwError(() => error);
        })
      ).toPromise() as unknown as HttpEvent<any>;
    }



  private handle401Error(req: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      const refreshToken = this.getRefreshToken();

      if (refreshToken) {
        return this.service.refreshToken(refreshToken).pipe(
          switchMap((res: any) => {
            this.isRefreshing = false;
            if(res.StatusCode == '000') {
              this.setToken(res.Result.AccessToken, res.Result.RefreshToken);
              return from(this.handleAccess(req, next));
            }else {
              this.router.navigate(['/login']);
              // return '';

              return throwError(() => new HttpErrorResponse({ 
                status: 401, 
                statusText: 'Unauthorized',
                error: { MsgResponse: { ResponseCode: '401', ResponseMsg: 'Session expired' } }
              }));
            }
          }),
          catchError((error) => {
            this.isRefreshing = false;
            // localStorage.removeItem(this.tokenKey);
            // localStorage.removeItem(this.refreshTokenKey);
            this.router.navigate(['/login']);
            // return throwError(() => error);

            return throwError(() => new HttpErrorResponse({ 
              status: 401, 
              statusText: 'Unauthorized',
              error: { MsgResponse: { ResponseCode: '401', ResponseMsg: 'Session expired' } }
            }));
          })
        );
      } else {
        this.router.navigate(['/login']);
        // return of(null);

        return throwError(() => new HttpErrorResponse({ 
          status: 401, 
          statusText: 'Unauthorized',
          error: { MsgResponse: { ResponseCode: '401', ResponseMsg: 'Session expired' } }
        }));
      }
    }
    // return of(null);

    return throwError(() => new HttpErrorResponse({ 
      status: 401, 
      statusText: 'Unauthorized',
      error: { MsgResponse: { ResponseCode: '401', ResponseMsg: 'Session expired' } }
    }));
  }



  private addTokenToHeader(request: HttpRequest<any>) {
    const token = this.getToken();
    if (token) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return request;
  }

  // private async addHashToRequest(request: HttpRequest<any>): Promise<HttpRequest<any>> {
  //   if(!request.body.MsgData.HashValue){
  //     const hashValue = await this.calculateHashForRequest(request.body, CipherModel.HASH_KEY);
  //     return request.clone({
  //       body: { ...request.body, MsgData: request.body.MsgData, HashValue: hashValue }
  //     });
  //   }
  // }

  private async addHashToRequest(request: HttpRequest<any>): Promise<HttpRequest<any>> {
    let currentBody = request.body;

    // 1. If it's a string, we MUST parse it to see the HashValue
    if (typeof currentBody === 'string') {
        try {
            currentBody = JSON.parse(currentBody);
        } catch (e) {
            return request; // Not a JSON string, leave it alone
        }
    }

    if (!currentBody) return request;

    const existingHash = currentBody['HashValue'];

    if (existingHash !== undefined && existingHash !== null && existingHash !== "") {
        console.log('Found it! Sibling HashValue exists. Moving on.');
        return request; 
    }

    const hashValue = await this.calculateHashForRequest(currentBody, CipherModel.HASH_KEY);
    
    return request.clone({
        body: {
            ...currentBody,
            HashValue: hashValue
        }
    });
}

  private async addHashToFormData(request: HttpRequest<any>): Promise<HttpRequest<any>> {
    const hashValue = await this.calculateHashForRequest(request.body, CipherModel.HASH_KEY);
    const formData = request.body;
    return request.clone({ body: formData });
  }

  private getToken = (): string | null => localStorage.getItem(ConstantValues.TokenKey);
  private getRefreshToken = (): string | null => localStorage.getItem(ConstantValues.RefreshTokenKey);
  private setToken = (token: string, refreshToken:string) => {localStorage.setItem(ConstantValues.TokenKey, token); localStorage.setItem(ConstantValues.RefreshTokenKey, refreshToken)}

  //#region hashing
  private async calculateHashForRequest(responseModel: any, secretKey: string): Promise<string> {
    try {
      // const reorderedRequest = {
        // MsgInfo: responseModel.MsgInfo,
        // MsgData: responseModel.MsgData,
        // HashValue: responseModel.HashValue
      // };

      let secretKey = "qpydp28JC53Xi6wdVodg/4t2mPWGp/8zIHXjb/8M";
 
      // Convert object to JSON string
      let jsonString = JSON.stringify(responseModel);
      
      // Generate HMAC SHA256 hash
      let hashValue: any = CryptoJS.HmacSHA256(jsonString, secretKey);
      
      // Convert to Base64
    // hashBase64 = CryptoJS.enc.Base64.stringify(hashValue);

      // let jsonString = JSON.stringify(responseModel);
      // debugger;
      // const jsonObject = JSON.parse(jsonString);
      // delete jsonObject.IsSuccess;
      // delete jsonObject.IsFailure;
      // delete jsonObject.Error;
      // delete jsonObject.HashValue;

      // jsonString = JSON.stringify(jsonObject);

      // const hash = CryptoJS.HmacSHA256(jsonString, secretKey);
      const hashInBase64 = CryptoJS.enc.Base64.stringify(hashValue);

      return hashInBase64;
    } catch (error) {
      return '';
    }
  }

  private async calculateHashForResponse(responseModel: any, secretKey: string): Promise<string> {
    try {
      const reorderedRequest = {
        // MsgInfo: responseModel.MsgInfo,
        // MsgData: responseModel.MsgData,
        // MsgResponse: responseModel.MsgResponse,
        // HashValue: responseModel.HashValue
      };

      let jsonString = JSON.stringify(responseModel, (key, value) => {
        if (value === null || value === undefined) {
          return undefined;
        }

        if (value instanceof Date) {
          return value.toISOString();
        }
        return value;
      }, 2);

      const jsonObject = JSON.parse(jsonString);

      delete jsonObject.IsSuccess;
      delete jsonObject.IsFailure;
      delete jsonObject.Error;
      delete jsonObject.HashValue;

      jsonString = JSON.stringify(jsonObject);
      const hash = CryptoJS.HmacSHA256(jsonString, secretKey);
      const hashInBase64 = CryptoJS.enc.Base64.stringify(hash);

      return hashInBase64;
    } catch (error) {
      return '';
    }
  }
  //#endregion
}